/* eslint-disable import/prefer-default-export */

export function getBoundingPoints(allTrips) {
  // Return two points to express extremes in all directions
  const tripPoints = allTrips.map((trip) => [
    parseFloat(trip.address_lat, 10),
    parseFloat(trip.address_lng, 10),
  ]);
  const tripLats = tripPoints.map((point) => point[0]);
  const tripLngs = tripPoints.map((point) => point[1]);
  const minLat = Math.min(...tripLats);
  const maxLat = Math.max(...tripLats);
  const minLng = Math.min(...tripLngs);
  const maxLng = Math.max(...tripLngs);
  const bottomLeftPoint = [minLng, minLat];
  const topRightPoint = [maxLng, maxLat];

  return [bottomLeftPoint, topRightPoint];
}
